const splitTime = (timestamp) => {
    const dataTime = timestamp.split('T', 2)
    const resultData = dataTime[0].concat(" ")
    const resultTime = dataTime[1].split('Z', 1)
    return resultData.concat(resultTime)
}

export default splitTime;